import React from 'react';
import { EditIcon, CalendarIcon, DollarSignIcon, Trash2Icon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export interface Earning {
  id: string;
  amount: number;
  date: string;
  type: 'Ladeboks' | 'Andet';
  customerId?: string;
  customerName?: string;
  notes?: string;
}
interface EarningCardProps {
  earning: Earning;
  index: number;
  onEdit: (earning: Earning) => void;
  onDelete: (earning: Earning) => void;
  readOnly?: boolean;
}
export function EarningCard({
  earning,
  index,
  onEdit,
  onDelete,
  readOnly = false
}: EarningCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.05
  }} className="bg-white rounded-xl p-5 shadow-sm border border-stone-100 hover:shadow-md transition-shadow duration-200" data-id="element-514">
      <div className="flex items-start justify-between mb-3" data-id="element-515">
        <div className="flex-1" data-id="element-516">
          <div className="flex items-center gap-2 mb-2" data-id="element-517">
            <span className={`px-3 py-1 text-xs font-medium rounded-full border ${earning.type === 'Ladeboks' ? 'bg-blue-100 text-blue-700 border-blue-200' : 'bg-purple-100 text-purple-700 border-purple-200'}`} data-id="element-518">
              {earning.type}
            </span>
          </div>
          <div className="flex items-center gap-2 text-sm text-stone-500 mb-2" data-id="element-519">
            <CalendarIcon className="w-4 h-4 text-teal-600" data-id="element-520" />
            <span data-id="element-521">{new Date(earning.date).toLocaleDateString('da-DK')}</span>
          </div>
          {earning.customerName && <div className="flex items-center gap-2 text-sm text-stone-600" data-id="element-522">
              <UserIcon className="w-4 h-4 text-blue-600" data-id="element-523" />
              <span className="font-medium" data-id="element-524">{earning.customerName}</span>
            </div>}
        </div>
        {!readOnly && <div className="flex items-center gap-1" data-id="element-525">
            <button onClick={() => onEdit(earning)} className="p-1.5 text-stone-400 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all" aria-label="Rediger indtjening" data-id="element-526">
              <EditIcon className="w-4 h-4" data-id="element-527" />
            </button>
            <button onClick={() => onDelete(earning)} className="p-1.5 text-stone-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all" aria-label="Slet indtjening" data-id="element-528">
              <Trash2Icon className="w-4 h-4" data-id="element-529" />
            </button>
          </div>}
      </div>

      {earning.notes && <div className="text-sm text-stone-600 mb-4 line-clamp-2" dangerouslySetInnerHTML={{
      __html: earning.notes
    }} data-id="element-530" />}

      <div className="pt-4 border-t border-stone-100" data-id="element-531">
        <div className="flex items-center justify-between" data-id="element-532">
          <div className="flex items-center gap-2" data-id="element-533">
            <DollarSignIcon className="w-4 h-4 text-emerald-600" data-id="element-534" />
            <span className="text-sm text-stone-500" data-id="element-535">Beløb</span>
          </div>
          <span className="text-xl font-bold text-emerald-700" data-id="element-536">
            +{earning.amount.toLocaleString('da-DK')} kr
          </span>
        </div>
      </div>
    </motion.article>;
}